import { render, staticRenderFns } from "./AUpdateProfile.vue?vue&type=template&id=cbfdfea6&"
import script from "./AUpdateProfile.vue?vue&type=script&lang=js&"
export * from "./AUpdateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports